import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** A further shop of the logged-in company, besides its business address. */
export interface StoreLocation {
  id: number;
  name: string;
  street: string;
  zip: string;
  city: string;
  country: string;
  /** Looked up in the background after each address change; null until then. */
  latitude: number | null;
  longitude: number | null;
}

export type StoreLocationInput = Pick<
  StoreLocation,
  'name' | 'street' | 'zip' | 'city' | 'country'
>;

@Injectable({
  providedIn: 'root',
})
export class StoreLocationService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/store-locations`;

  list(): Observable<StoreLocation[]> {
    return this.http.get<StoreLocation[]>(this.apiUrl);
  }

  create(input: StoreLocationInput): Observable<StoreLocation> {
    return this.http.post<StoreLocation>(this.apiUrl, input);
  }

  update(id: number, input: StoreLocationInput): Observable<StoreLocation> {
    return this.http.put<StoreLocation>(`${this.apiUrl}/${id}`, input);
  }

  delete(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}
